import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBlobQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetBlobQuery = { __typename?: 'Query', blob: { __typename?: 'Blob', id: string, name: string } };

export type GetEmployeeCompanyIdQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetEmployeeCompanyIdQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: string, company: { __typename?: 'Company', id: string } } };

export type GetCurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, tenant: Types.Tenant } };


export const GetBlobDocument = gql`
    query GetBlob($id: ID!) {
  blob(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetBlobQuery__
 *
 * To run a query within a React component, call `useGetBlobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBlobQuery(baseOptions: Apollo.QueryHookOptions<GetBlobQuery, GetBlobQueryVariables> & ({ variables: GetBlobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBlobQuery, GetBlobQueryVariables>(GetBlobDocument, options);
      }
export function useGetBlobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBlobQuery, GetBlobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBlobQuery, GetBlobQueryVariables>(GetBlobDocument, options);
        }
export function useGetBlobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBlobQuery, GetBlobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBlobQuery, GetBlobQueryVariables>(GetBlobDocument, options);
        }
export type GetBlobQueryHookResult = ReturnType<typeof useGetBlobQuery>;
export type GetBlobLazyQueryHookResult = ReturnType<typeof useGetBlobLazyQuery>;
export type GetBlobSuspenseQueryHookResult = ReturnType<typeof useGetBlobSuspenseQuery>;
export type GetBlobQueryResult = Apollo.QueryResult<GetBlobQuery, GetBlobQueryVariables>;
export const GetEmployeeCompanyIdDocument = gql`
    query GetEmployeeCompanyId {
  employee {
    id
    company {
      id
    }
  }
}
    `;

/**
 * __useGetEmployeeCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetEmployeeCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeCompanyIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeCompanyIdQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeCompanyIdQuery, GetEmployeeCompanyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeCompanyIdQuery, GetEmployeeCompanyIdQueryVariables>(GetEmployeeCompanyIdDocument, options);
      }
export function useGetEmployeeCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeCompanyIdQuery, GetEmployeeCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeCompanyIdQuery, GetEmployeeCompanyIdQueryVariables>(GetEmployeeCompanyIdDocument, options);
        }
export function useGetEmployeeCompanyIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeCompanyIdQuery, GetEmployeeCompanyIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeeCompanyIdQuery, GetEmployeeCompanyIdQueryVariables>(GetEmployeeCompanyIdDocument, options);
        }
export type GetEmployeeCompanyIdQueryHookResult = ReturnType<typeof useGetEmployeeCompanyIdQuery>;
export type GetEmployeeCompanyIdLazyQueryHookResult = ReturnType<typeof useGetEmployeeCompanyIdLazyQuery>;
export type GetEmployeeCompanyIdSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeCompanyIdSuspenseQuery>;
export type GetEmployeeCompanyIdQueryResult = Apollo.QueryResult<GetEmployeeCompanyIdQuery, GetEmployeeCompanyIdQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  user {
    id
    tenant
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;